import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from '../../components/feature/HeroSection';
import TrustBar from '../../components/feature/TrustBar';
import ServicesSection from '../../components/feature/ServicesSection';
import AIAnswerBlock from '../../components/feature/AIAnswerBlock';
import ProcessSection from '../../components/feature/ProcessSection';
import WhyChooseUs from '../../components/feature/WhyChooseUs';
import ServiceAreasSection from '../../components/feature/ServiceAreasSection';
import TestimonialsSection from '../../components/feature/TestimonialsSection';
import FAQSection from '../../components/feature/FAQSection';
import FinalCTA from '../../components/feature/FinalCTA';
import { servicesFaqs } from '../../mocks/faqs';

const heroContent = {
  badge: 'Expert Craftsmanship, Every Service',
  headline: 'Home Improvement Services That Set the Standard.',
  subheadline: 'From Floors to Roof — We Do It All.',
  description: 'Comprehensive professional services for Houston TX homeowners and property managers. Every project handled with precision, transparency, and a 100% satisfaction guarantee.',
  primaryCTA: { text: 'Get Free Quote', href: '#quote' },
  secondaryCTA: { text: 'See All Services', href: '#services' },
  backgroundImage: 'https://public.readdy.ai/ai/img_res/c891d054949baaeb16de582527e2b170.jpg',
  stats: [
    { value: '6', label: 'Core Services' },
    { value: '16+', label: 'Years Experience' },
    { value: '100%', label: 'Satisfaction Guarantee' },
    { value: '7 Days', label: 'Available' },
  ],
};

const aiContent = {
  eyebrow: 'AI Answer Block',
  title: 'Our Houston Home Improvement Services Explained',
  lead: 'One Call Handyman Service provides six professional home improvement services across Houston TX and surrounding areas — all backed by 16+ years of expertise, transparent pricing, and a satisfaction guarantee.',
  points: [
    {
      icon: 'ri-home-gear-line',
      title: 'Make-Ready Remodeling',
      body: 'Prepare your Houston property for new occupants with professional make-ready service. Interior painting, fixture replacement, flooring repairs, drywall patching, and complete tenant-turnover solutions.',
    },
    {
      icon: 'ri-layout-grid-line',
      title: 'Flooring Installation',
      body: 'Hardwood, luxury vinyl plank, tile, laminate, and stone flooring installed throughout Houston TX. Subfloor preparation, repairs, refinishing, and baseboard installation all included.',
    },
    {
      icon: 'ri-paint-brush-line',
      title: 'Drywall & Painting',
      body: 'Interior and exterior painting, drywall installation and repair, texture matching, water damage restoration, and popcorn ceiling removal for Houston homes and properties.',
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Electrical Services',
      body: 'Outlet and switch replacement, light fixture installation, ceiling fan installation, GFCI upgrades, and code compliance repairs throughout Houston TX homes and properties.',
    },
    {
      icon: 'ri-drop-line',
      title: 'Plumbing Services',
      body: 'Faucet repair and replacement, toilet installation, water heater services, leak detection, drain cleaning, and full fixture installation across Houston and surrounding areas.',
    },
    {
      icon: 'ri-building-2-line',
      title: 'Roofing Services',
      body: 'Roof inspection, shingle repair and replacement, storm damage repair, leak fixes, gutter cleaning, and soffit repair for Houston TX homeowners. Protecting your property year-round.',
    },
  ],
};

export default function ServicesPage() {
  return (
    <main className="pb-16 lg:pb-0">
      <Navbar />
      <HeroSection content={heroContent} />
      <TrustBar />
      <ServicesSection
        title="Every Service. One Trusted Provider."
        subtitle="Six professional home improvement services delivered across Houston TX with 16+ years of experience, fair pricing, and a satisfaction guarantee."
        layout="detailed"
        bg="white"
      />
      <AIAnswerBlock content={aiContent} />
      <ProcessSection />
      <WhyChooseUs
        image="https://topratedhomepros.com/website/sites-images/handy1man/process-200x200-3-contractor-working-on-project.jpg"
        title="The Difference Is in the Detail"
        subtitle="We don't just show up — we show up prepared, professional, and committed to leaving every Houston property better than we found it."
      />
      <ServiceAreasSection
        title="Services Available Throughout Greater Houston"
        subtitle="All six services available across Houston TX and surrounding communities. Professional results wherever you call home."
      />
      <TestimonialsSection />
      <FAQSection
        faqs={servicesFaqs}
        title="Service-Specific Questions, Answered"
        subtitle="What Houston homeowners ask most about our individual services — direct, voice-search-ready answers."
        bg="cream"
      />
      <FinalCTA
        headline="Which Service Does Your Houston Property Need?"
        subheadline="Request your free detailed quote. We explain every step before we start — no surprises, no hidden costs."
      />
      <Footer />
    </main>
  );
}
